import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default Bar.extend({
  data () {
    return {
    }
  },
  mixins: [ reactiveProp ],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/components/module/barChart.js